import { zodResolver } from '@hookform/resolvers/zod';
import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import {
  handleAddressDetailsGeocode,
  retryAddressDetailsGeocode,
} from '@porterin/booking-flow/src/order-review/view/helpers/GeoCodeHelper';
import { useHook } from '@porterin/booking-flow/src/order-review/view/hooks/GoogleAutoCompleteHook';
import {
  FormData,
  schema,
  AddressType,
} from '@porterin/booking-flow/src/order-review/view/types/OrderReviewAddressSchema';
import { SelectLocationViewCmp } from '@porterin/component-library/src/location-accuracy/components/SelectLocationViewCmp';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { getGoogleMapsHookConfig } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers';
import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import React from 'react';
import { useForm } from 'react-hook-form';
const Config: AppConfig = getAppConfig();

export interface SelectLocationProps {
  close_modal: () => void;
}

export const SelectLocationControllerCmp: React.FC<SelectLocationProps> = ({
  close_modal,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
  } = useForm<FormData>({
    mode: 'onBlur',
    resolver: zodResolver(schema),
  });

  const { selectLocation, state } = useLocation();
  const { getPredictions, predictions, resetPredictions } = useHook(
    getGoogleMapsHookConfig(),
  );

  const handleAddressChange = (event: any) => {
    try {
      if (event.target.value.length >= 2) {
        getPredictions({ input: event.target.value });
      } else {
        resetPredictions();
      }
    } catch (_) {
      console.error('Error getting predictions');
    }
  };

  const addressOnChange = (extended_address: ExtendedAddress) => {
    selectLocation(extended_address);
  };

  const handlePredictionClick = (
    prediction: google.maps.places.AutocompletePrediction,
  ): void => {
    handleAddressDetailsGeocode(
      prediction.place_id,
      (address: ExtendedAddress) => {
        addressOnChange(address);
      },
      (_error: any) => {
        retryAddressDetailsGeocode(
          prediction.place_id,
          (address: ExtendedAddress) => addressOnChange(address),
          prediction.description,
        );
      },
      prediction.description,
    );
    resetPredictions();
  };

  const updateField = register(
    state.waypoint === 'Pickup' ? AddressType.pickup : AddressType.drop,
    { onChange: handleAddressChange },
  );

  return (
    <SelectLocationViewCmp
      close_modal={close_modal}
      predictions={predictions}
      on_prediction_click={handlePredictionClick}
      error={errors?.root?.message}
      register={updateField}
    />
  );
};
